import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ThankYou } from './pages/ThankYou';
import { BookTour } from './pages/BookTour';
import { landingVariants } from './data/landingVariants';
const [bayArea, northernCalifornia, outOfState] = landingVariants;
const knownPaths = ['/bay-area', '/northern-california', '/out-of-state', '/book-tour', '/thank-you'];
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mm2ji848kh09">
      <FallbackRedirect data-id="element-1" data-mp="2mmvkstkfeeb0" />
      <Routes data-id="element-2" data-mp="2mndr6j0sy8wn">
        <Route path="/bay-area" element={<LandingPage variant={bayArea} data-id="element-4" data-mp="31agpgrwy8ll1" />} data-id="element-3" data-mp="2mjpwhgjmfggc" />
        <Route path="/northern-california" element={<LandingPage variant={northernCalifornia} data-id="element-6" data-mp="2wk0av4he6tx3" />} data-id="element-5" data-mp="31c9vq63nh3si" />
        <Route path="/out-of-state" element={<LandingPage variant={outOfState} data-id="element-8" data-mp="28ufp6dtutik4" />} data-id="element-7" data-mp="2wifgbev2vaz8" />
        <Route path="/book-tour" element={<BookTour data-id="element-10" data-mp="28sb9yzqi8x4j" />} data-id="element-9" data-mp="28t4m6g88geu2" />
        <Route path="/thank-you" element={<ThankYou data-id="element-12" data-mp="23u9ueosaffxt" />} data-id="element-11" data-mp="23vcmh01cjofb" />
      </Routes>
    </BrowserRouter>;
}

// Sends the domain root (and any unknown address) to the Bay Area page
// without registering an extra route.
function FallbackRedirect() {
  const {
    pathname
  } = useLocation();
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (knownPaths.includes(normalized)) return null;
  return <Navigate to="/bay-area" replace data-id="element-13" data-mp="3relwkmdx3sbc" />;
}